import { app } from '@/main'
import variables from './variables'

const helpers = {
  // capitalize string
  capitalize: (string) => {
    string = string.toLowerCase()
    return string.charAt(0).toUpperCase() + string.slice(1)
  },

  getProductImageUrl: (product, index = 0) => {
    if (product.images.length) {
      return `${variables.S3BucketUrl}${product.images[index]}`
    }

    return false
  },

  toastError: (message) => {
    app.$toast.error(message, {
      timeout: 0
    })
  },

  toastSuccess: (message) => {
    app.$toast.success(message)
  }
}

export default helpers



// WEBPACK FOOTER //
// ./src/utils/helpers.js